import { render, staticRenderFns } from "./EmployeeSearch.vue?vue&type=template&id=5bcc0ca9&scoped=true&"
import script from "./EmployeeSearch.vue?vue&type=script&lang=js&"
export * from "./EmployeeSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc0ca9",
  null
  
)

export default component.exports